module.exports = __webpack_public_path__ + "static/media/logo-atlassian.3dc00559.svg";